import api from '@/lib/axios';

export interface Settings {
  _id: string;
  key: string;
  liveChatEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

// Mesai saatleri için tipler
export interface DaySchedule {
  start: string;
  end: string;
  enabled: boolean;
}

export interface DisplayRow {
  label: string;
  startTime: string | null;
  endTime: string | null;
  enabled: boolean;
}

export interface BusinessHours {
  enabled: boolean;
  displayRows: DisplayRow[];
  schedule: {
    monday: DaySchedule;
    tuesday: DaySchedule;
    wednesday: DaySchedule;
    thursday: DaySchedule;
    friday: DaySchedule;
    saturday: DaySchedule;
    sunday: DaySchedule;
  };
}

export const settingsService = {
  // Ayarları getir
  async getSettings(): Promise<Settings> {
    const response = await api.get('/settings');
    return response.data.data;
  },

  // Ayarları güncelle
  async updateSettings(updates: Partial<Pick<Settings, 'liveChatEnabled'>>): Promise<Settings> {
    const response = await api.put('/settings', updates);
    return response.data.data;
  },

  // Mesai saatlerini getir
  async getBusinessHours(): Promise<BusinessHours> {
    const response = await api.get('/settings/business-hours');
    return response.data.data;
  },

  // Mesai saatlerini güncelle
  async updateBusinessHours(updates: Partial<BusinessHours>): Promise<BusinessHours> {
    const response = await api.put<{ success: boolean; data: BusinessHours }>('/settings/business-hours', updates);
    return response.data.data;
  }
};
